import { atom } from "recoil"

export const inquiryContentState = atom<string | undefined>({
  key: "atoms/settings/inquiryContentState",
  default: undefined,
})
